import React from 'react';
import Skeleton from 'wsm-skeleton';
import { setClassNames } from 'ddc-classnames-js';

const CustomSkeleton = () => {
	return (
		<Skeleton
			skeletonClasses="m-auto"
			width="100%"
			height="calc(1em * 1.5)"
		/>
	);
};

const ReviewLoader = ({ ...deletagedProps }) => {
	// CSS classes
	const reviewLoaderClasses = [
		deletagedProps.className ? deletagedProps.className : ''
	];

	return (
		<div
			className={`review-loader between-dotted-underline ${setClassNames(
				reviewLoaderClasses
			)}`}
			role="listitem"
			aria-label="Loading Profile Card"
		>
			<div className="row">
				<div className="col-sm-2 pt-3">
					<CustomSkeleton />
				</div>
				<div className="col-sm-2 pt-3">
					<CustomSkeleton />
				</div>
				<div className="col-sm-2 pt-3 col-sm-offset-6">
					<CustomSkeleton />
				</div>
			</div>
			<div className="row">
				<div className="col-sm-2 pt-3">
					<CustomSkeleton />
				</div>
				<div className="col-sm-2 pt-3">
					<CustomSkeleton />
				</div>
				<div className="col-sm-3 pt-3">
					<CustomSkeleton />
				</div>
			</div>
			<div className="row mb-4">
				<div className="col-sm-12 pt-3">
					<CustomSkeleton />
				</div>
			</div>
		</div>
	);
};

export default ReviewLoader;
